import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./components/welcome-dashboard/welcome-dashboard.component').then(m => m.WelcomeDashboardComponent)
    },
    {
        path: 'section',
        loadComponent: () =>
            import('./components/section-viewer/section-viewer.component').then(m => m.SectionViewerComponent)
    },
    {
        path: 'chapters',
        loadComponent: () =>
            import('./components/chapter-browser/chapter-browser.component').then(m => m.ChaptersBrowserComponent)
    },
    {
        path: 'exams',
        loadComponent: () =>
            import('./components/exam-viewer/exam-viewer.component').then(m => m.ExamViewerComponent)
    },
    { path: '**', redirectTo: '' }
];